import "./App.css";
var bg = "./Asserts/BG.png";

function App() {
  return (
    <div
      style={{
        backgroundImage: `  url(${bg})`,
      }}
      className="app"
    >
      <div className="navbars">
        <div className="container">
          <div className="row">
            <div className="col-6">
              <img className="img-fluid" src="./Asserts/logo.png" alt="" />
            </div>
            <div className="col-6 align-self-center justify-content-end">
              <a target={"_blank"} href="https://discord.gg/sbqqgND2">
                Discord
              </a>
              <a target={"_blank"} href="https://twitter.com/Kingdoms_fi">
                Twitter
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="assure">
        <div className="container">
          <img src="./Asserts/assure.png" className="img-fluid" alt="" />
        </div>
      </div>

      <div className="hero-section">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <div className="king">
                <img src="./Asserts/king.png" className="img-fluid" alt="" />
              </div>

              <img
                src="./Asserts/chess.png"
                className="img-fluid pt-6"
                alt=""
              />
              <br />
              <a className="enter-app" href="">
                Enter App
              </a>
              <a
                className="documentation"
                href="https://kingdoms-financial.gitbook.io/kingdoms-financial/"
              >
                Documentation
              </a>

              <h6>The King of DeFi</h6>
              <p>
                An easy-to-use tool to grow your riches - sacrifice Pawns to
                earn passive income.
                <br />
                <p>Backed by a community-owned treasury.</p>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="chesscoin d-flex justify-content-center">
          <img src="./Asserts/chesscoin.png" alt="" />
          <h5>Coming Soon to</h5>
          <img className="polyngon" src="./Asserts/fantum.svg" alt="" />
        </div>
      </div>
    </div>
  );
}

export default App;
